import React from 'react'
import {Link} from 'react-router-dom'
class PrivacyPolicy extends React.Component{
render(){
return(
<div class="About">
   <div className="container">
      <div className="row">
         <div className="col-md-12">
            <div className="terms-condition">
               <h3>HOME PRIVACY POLICY</h3>
               <p>Last updated:????????</p>
               <ul>
                  <li>
                     
                     Rana Abdul Rahim & partners LLC ("us", "we", or "our") operates <Link to="privacy-policy">www.??????????????.com</Link> (the "Site"). This page informs you of our policies regarding the collection, use and disclosure of Personal Information we receive from users of the Site.
                  </li>
                  <li>
                     We use your Personal Information only for providing and improving the Site. By using the Site, you agree to the collection and use of information in accordance with this policy.
                  </li>
                  
                  <li>
                  <p>Information Collection and Use</p>
                     while using our Site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to your name ("Personal Information").
                  </li>
                 
                  <li>
                   <p>Log Data</p>
                    Like many site operators, we collect information that your browser sends whenever you visit our Site ("Log Data").

                  </li>
                  <li>
                     This Log Data may include information such as your computer's Internet Protocol ("IP") address, browser type, browser version, the pages of our Site that you visit, the time and date of your visit, the time spent on those pages and other statistics.
                  </li>
                  <li>
                     In addition, we may use third party services such as Google Analytics that collect, monitor and analyse this.
                  </li>
                  
                  <li>
                  <p>Communications</p>
                     We may use your Personal Information to contact you with newsletters, marketing or promotional materials and other information that we will use to communicate with you from time to time.
                  </li>
                  
                  <li>
                  <p>Cookies</p>
                     Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive.
                  </li>
                  <li >Like many sites, we use "cookies" to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Site.</li>
                  
                  <li ><p>Security</p>The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.
                  </li>
                  
                  <li ><p>Changes to This Privacy Policy</p> This Privacy Policy is effective as of????? and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.
                  </li>
                  <li>We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.
                  </li>
                  <li>If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.
                  </li>
                 
                  <li>
                      <p>Contact Us</p>
                     if you have any questions about this Privacy Policy, please contact us on <Link to="/privacy-policy"></Link>
                  </li>
                  
               </ul>
               
               <p className="last-line-condition"> <Link to="privacy-policy">PRIVACY POLICY</Link> | <Link to="/termsandcondition">TERMS & CONDITIONS</Link> | <Link to="/">SITE MAP</Link> </p>
            </div>
         </div>
      </div>
   </div>
</div>
)
}
}
export default PrivacyPolicy;